import {i18n} from '@online-offer/i18n';
import {Box, HStack, Text, VStack} from 'platform/foundation';

import {Nullish} from 'shared/web';

import {Button} from '../../components/Button/Button';

type FinancialProductSummaryRowProps = {
  id: string;
  label: string;
  amount: string | Nullish;
  onCalculate: VoidFunction;
};

export function FinancialProductSummaryRow(props: FinancialProductSummaryRowProps) {
  return (
    <HStack justify="space-between" align="center" spacing={3}>
      <VStack spacing={0} minWidth={0}>
        <Text size="small" color="secondary" overflowWrap="anywhere">
          {props.label}
        </Text>
        <HStack spacing={1} align="baseline" minWidth={0} wrap>
          <div
            role="heading"
            aria-level={4}
            data-testid={`financialProductSummary-${props.id}-monthlyPayment-heading`}
          >
            <Text size="large" alternative overflowWrap="anywhere">
              {props.amount}
            </Text>
          </div>
          <Text size="small" color="secondary">
            {i18n.t('financialProducts.perMonth')}
          </Text>
        </HStack>
      </VStack>
      <Box flexShrink={0}>
        <Button
          variant="outline"
          size="small"
          title={i18n.t('financialProducts.calculate')}
          onClick={props.onCalculate}
          data-testid={`financialProductSummary-${props.id}-calculate`}
        />
      </Box>
    </HStack>
  );
}
